//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  /* components: {
  }, */
  data: function () {
    return {
      openWarning: false,
      thumbStyle: {
        right: '4px',
        borderRadius: '5px',
        background: '#A9A9A9',
        width: '10px',
        opacity: 1
      },
      employees: null
    }
  },
  methods: {
    onOpen: function () {
      this.openWarning = true
    },
    onFinish: function (answer) {
      this.openWarning = false
      this.$emit('action-finish', answer)
    }
  }
}
